import Text from '../../../../components/Text'

const PlanExpired = ({ viemaxImgUrls, onExtendPlan = () => {} }) => {
  return (
    <section className="bg-[#F6EDFF]">
      {/* Plan Expired Section */}
      <img
        src={viemaxImgUrls.planExpiredImage}
        alt="Viemax Success Image"
        className="w-full h-full object-cover"
      />
      <div className="px-5 mb-1 relative -top-6">
        <div className="bg-[#1C1C1E] rounded-2xl p-6 relative overflow-hidden">
          <div className="text-center space-y-3">
            <Text
              variant="title"
              size="large"
              tag="p"
              bold={'true'}
              textalign="center"
              className="text-[#FF9494]"
            >
              Your Viemax Care Program has expired. Time to renew!
            </Text>

            <Text
              variant="body"
              size="medium"
              tag="p"
              textalign="center"
              className="text-white"
            >
              To continue your Viemax Care Program, please get a new pack and
              scan the QR code inside to restart your journey.
            </Text>

            <button
              className="w-full bg-[#299D6B] text-white py-3 px-4 rounded-lg font-medium hover:bg-[#238a5f] transition-colors"
              onClick={onExtendPlan}
            >
              Extend Your Program
            </button>
          </div>
        </div>
      </div>

      <img
        src={viemaxImgUrls?.wavyBorder}
        alt="Wavy Border"
        className="w-full h-4"
      />
    </section>
  )
}

export default PlanExpired
